import { graphql } from 'react-relay/hooks'
import { ConnectionHandler } from 'react-relay'
import { useMutation } from 'hooks'

const mutation = graphql`
  mutation useReportTemplateArchiveMutation($input: ArchiveReportTemplateInput!) {
    archiveReportTemplate(input: $input) {
      reportTemplate {
        id
        organization {
          id
        }
      }
    }
  }
`

const updater = (store, { archiveReportTemplate }) => {
  const organization = store.get(archiveReportTemplate.reportTemplate.organization.id)

  const connection = ConnectionHandler.getConnection(
    organization,
    'TemplatesTable_reportTemplates',
    {
      orderBy: 'CREATED_AT_DESC',
    },
  )

  if (connection) {
    ConnectionHandler.deleteNode(connection, archiveReportTemplate.reportTemplate.id)
  }
}

export default function useReportTemplateArchive() {
  return useMutation(mutation, 'archiveReportTemplate', { updater })
}
